<script setup></script>

<template>
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="2.5" width="12" height="12" rx="6" />
    <path d="M5.87891 6.37842L10.1215 10.6211" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M5.87891 10.6211L10.1215 6.37842" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<style scoped lang="scss"></style>
